export const inputStyle = {
    fontWeight: 'bold',
};